import { render, staticRenderFns } from "./GeneralActionButton.vue?vue&type=template&id=6ddc2c06&"
import script from "./GeneralActionButton.vue?vue&type=script&lang=js&"
export * from "./GeneralActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports